import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../../openapi';
import {
  OpinionOnIssuingADecisionInvestorItemForm
} from '../../forms/opinion-on-issuing-a-decision-investor-item.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-opinion-on-issuing-a-decision-investor-company-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent
  ],
  templateUrl: './opinion-on-issuing-a-decision-investor-company-form.component.html'
})
export class OpinionOnIssuingADecisionInvestorCompanyFormComponent implements OnInit {

  private entityType = '8172a696-2a3b-402a-b262-dfcf37404da3';

  @Input()
  public form: OpinionOnIssuingADecisionInvestorItemForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  @Input()
  public edit = false;

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.entityType });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.entityType });
  }

  public ngOnInit(): void {
    this?.form?.applicantType.setValue(this.entityType);

    this.form?.name.enable();
    this.form?.nip.enable();

    this.form?.firstName.disable();
    this.form?.lastName.disable();
  }

}
